<template>
  <div :class="wrapperClass">
    <router-view name="mainLayout" key="mainLayout"></router-view>
    <router-view name="conferenceLayout" key="conferenceLayout"></router-view>
    <router-view name="wavveon" key="wavveonLayout"></router-view>
    <router-view name="member" key="member"></router-view>
    <router-view name="adult" key="adult"></router-view>
    <router-view name="voucher_popup" key="voucher_popup"></router-view>
    <router-view name="callback" key="callback"></router-view>
    <router-view name="construction" key="construction"></router-view>
    <router-view name="event_emergency" key="event_emergency"></router-view>
    <router-view name="notfound" key="notfound"></router-view>
    <router-view name="waiting" key="waiting"></router-view>
    <EventProcessor/>
  </div>
</template>
<script>
import EventProcessor from '@/components/EventProcessor'
import { logger, sendKnock } from '@/common/utils/common'
export default {
  components: { EventProcessor },
  computed: {
    wrapperClass () {
      // TODO: 2021년 1월 12일 이후 삭제 요망
      return window.uaInfo.getBrowser().name === 'IE' ? 'notice-open' : ''
    }
  },
  created () {
    sendKnock()
  }
}
if (process.env.NODE_ENV !== 'production') {
  logger('red')('---------LOCAL DEV MODE---------')
  logger('red')('---------LOCAL DEV MODE---------')
  logger('red')('---------LOCAL DEV MODE---------')
}

</script>
<style lang="css" src="@/assets/css/common.css"></style>
<style lang="css" src="@/assets/css/base.css"></style>
<style>
/**
  TODO: 2021년 1월 12일 (IE10, IE11 지원종료 이후)
  .notice-open 관련 로직 제거 해야 됨
 */
.notice-open {
  margin-top: 208px;
}
.notice-open .mypooq{
  margin-top: -109px;
}
</style>
<!--<style lang="css" src="@/assets/css/main.css"></style>-->
<!--<style lang="css" src="@/assets/css/mypooq.css"></style>-->
